export default __webpack_public_path__ + "e016d62032861464136026e70a3d4536.svg";